export type HandsetState =
  | 'available'
  | 'busy'
  | 'unanswered'
  | 'unreachable'
  | 'off'

export interface HandsetCondition {
  id: HandsetState
  label: string
}

/** The same four answering conditions the product exposes on the home screen. */
export const handsetConditions: HandsetCondition[] = [
  { id: 'busy', label: 'Busy' },
  { id: 'unanswered', label: 'Unanswered' },
  { id: 'unreachable', label: 'Unreachable' },
  { id: 'off', label: 'Phone off' },
]

export const handsetStateLabel: Record<HandsetState, string> = {
  available: 'Available',
  busy: 'Busy',
  unanswered: 'Unanswered',
  unreachable: 'Unreachable',
  off: 'Phone off',
}
